import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingQHPService from "@app/overviews/network-benchmarking-dashboard/benchmarkingQHPService";
import { PrimaryFilterOptionUpdates } from "@app/overviews/network-benchmarking-dashboard/marketplace/filters/shared/PrimaryFilterOptionUpdates";

export interface QHPPrimaryFilterOptionUpdatesResult {
  isLoading: boolean;
  primaryFilterUpdates: PrimaryFilterOptionUpdates | undefined;
}

export const QHP_PRIMARY_FILTER_UPDATES_QUERY_KEY_PREFIX = "qhp-primary-filter-updates";

export const useQHPPrimaryFilterOptionUpdates = (
  clientId: number | undefined,
  stateId: number | undefined,
  enabled: boolean
): QHPPrimaryFilterOptionUpdatesResult => {
  const benchmarkingQHPService = useMemo(() => new BenchmarkingQHPService(), []);

  const queryResult = useQuery<PrimaryFilterOptionUpdates>({
    enabled: enabled && !!stateId,
    queryFn: ({ signal }) => benchmarkingQHPService.getPrimaryFilterOptionUpdates(stateId as number, null, signal),
    queryKey: [QHP_PRIMARY_FILTER_UPDATES_QUERY_KEY_PREFIX, clientId, stateId],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isLoading: queryResult.isFetching,
    primaryFilterUpdates: queryResult.data,
  };
}

export default useQHPPrimaryFilterOptionUpdates;
